<div class="dialog-wrapper">
  <h1 mat-dialog-title class="header">
    {{ dialogData?.title }}
  </h1>
  <mat-dialog-content>
    <div class="message">
      {{ dialogData?.content }}
    </div>
    @if (dialogData?.additionalContent) {
      <div class="message">
        {{ dialogData.additionalContent }}
      </div>
    }
    <mat-dialog-actions class="mb-0" align="end">
      @if (!dialogData?.hideCancelBtn) {
        <button
          mat-raised-button
          (click)="onNoClick()"
          type="button"
          color="primary"
        >
          {{ dialogData?.cancelBtnName ?? 'No' }}
        </button>
      }
      <button
        mat-raised-button
        [mat-dialog-close]="true"
        cdkFocusInitial
        type="submit"
        color="primary"
        >
        {{ dialogData?.confirmBtnName ?? 'Yes' }}
      </button>
    </mat-dialog-actions>
  </mat-dialog-content>
</div>
